var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top",class:{ 'back-to-top-active': _vm.active }},[_c('button',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.scrollUp($event)}}},[_vm._v("Back to Top")])])}
var staticRenderFns = []

export { render, staticRenderFns }